<deephub-design-image-feed
    [mltask]="mltask"
    [selectedCategories]="selectedCategories"
    [pathColumn]="pathColumn"
    [managedFolderSmartId]="managedFolderSmartId">
</deephub-design-image-feed>